// FILE: apps/admin/src/toast.tsx
// VERSION: 1.0.0
// START_MODULE_CONTRACT
//   PURPOSE: Core business logic and definitions for toast.
//   SCOPE: toast operations, models, and helper routines.
//   DEPENDS: none
//   LINKS: M-ADMIN
//   ROLE: RUNTIME
//   MAP_MODE: EXPORTS
// END_MODULE_CONTRACT
//
// START_MODULE_MAP
//   ToastProvider - Exported ToastProvider definition
//   useToast - React hook for Toast
// END_MODULE_MAP

import { createContext, type ReactNode, useCallback, useContext, useState } from 'react';

const ToastCtx = createContext<(msg: string) => void>(() => {});

// START_CONTRACT: useToast
//   PURPOSE: Execute useToast handler or component.
//   INPUTS: Defined in function signature
//   OUTPUTS: Return value matching signature
//   SIDE_EFFECTS: none
//   LINKS: M-ADMIN
// END_CONTRACT: useToast
export const useToast = () => useContext(ToastCtx);

// START_CONTRACT: ToastProvider
//   PURPOSE: Execute ToastProvider operation.
//   INPUTS: Defined in function signature
//   OUTPUTS: Return value matching signature
//   SIDE_EFFECTS: none
//   LINKS: M-ADMIN
// END_CONTRACT: ToastProvider
export function ToastProvider({ children }: { children: ReactNode }) {
  // START_BLOCK_TOAST_PROVIDER
  const [msg, setMsg] = useState<{ text: string; key: number } | null>(null);
  const show = useCallback((text: string) => {
    setMsg({ text, key: Date.now() });
    setTimeout(() => setMsg(null), 2600);
  }, []);
  return (
    <ToastCtx.Provider value={show}>
      {children}
      {msg && (
        <div className="toast" key={msg.key}>
          {msg.text}
        </div>
      )}
    </ToastCtx.Provider>
  );

  // END_BLOCK_TOAST_PROVIDER
}
